import React from 'react';
import {
  ConnectSecondarySocialProfilesModalController,
  ConnectSecondarySocialProfilesModalControllerProps
} from './ConnectSecondarySocialProfilesModal.controller';
import { gql } from '@apollo/client';
import { useConnectSecondarySocialProfilesMutation } from '../../../../models/graphql';

export type ConnectSecondarySocialProfilesModalApolloProps = Omit<
  ConnectSecondarySocialProfilesModalControllerProps,
  'connectSecondarySocialProfilesMutation' | 'loading'
> & {
  //
};

gql`
  mutation ConnectSecondarySocialProfiles(
    $workspaceId: ID!
    $socialAuthToken: String!
    $profilesNetwork: Network!
    $profiles: [SecondaryProfileConnectionInput!]!
  ) {
    connectSecondarySocialProfiles(
      workspaceId: $workspaceId
      socialAuthToken: $socialAuthToken
      profilesNetwork: $profilesNetwork
      profiles: $profiles
    ) {
      connected
      reconnected
      socialProfile {
        ...SocialProfileFields
      }
      additionalReconnection
      error
    }
  }
`;

export const ConnectSecondarySocialProfilesModalApollo = (
  props: ConnectSecondarySocialProfilesModalApolloProps
): JSX.Element => {
  const [connectSecondarySocialProfilesMutation, { loading }] = useConnectSecondarySocialProfilesMutation();

  const args: ConnectSecondarySocialProfilesModalControllerProps = {
    ...props,
    connectSecondarySocialProfilesMutation,
    loading
  };

  return <ConnectSecondarySocialProfilesModalController {...args} />;
};
